export function initVideoFallback() {
  const _wistiaEnabled = window.wistiaEnabled;


  if(!_wistiaEnabled) {
    //console.log("LOADING VID FALLBACK");
    var _setDetect, cookiePrefLink, autoReloadSet = false;

    function setAutoReload() {
      //console.log("setting auto reload");
      var apiObject = {PrivacyManagerAPI: { action:'getConsentDecision', timestamp: new Date().getTime(), self: 'ulprospectorweb.com' }};
      var json = JSON.stringify(apiObject); window.top.postMessage(json,'*');
      window.addEventListener('message',function(e) {
        let data = JSON.parse(e.data);

        if(data.message === 'submit_preferences') {
          let perms = data.data.split(",");
          if(perms.includes("1")) {
            location.reload();
          }
        };
      }, false);
    }

    function _setDetectClick(el, e) {
      var _closeEl = el.querySelector(".ul-popover__close");

      function _stopDetection(_el, _e) {
        //remove listener and destroy popover
        _el.querySelector(".ul-popover.cookiePopover").remove();
        //stop propagation (otherwise popover reopens and prevents cookie pref open click)
        _e.stopImmediatePropagation();
        _e.preventDefault();
        //console.log("stopping click propogation");
        try {
          document.removeEventListener("click", _setDetect, true);
        }
        catch(err) {
          console.log(err);
        }
      }

      if(e.target.hasAttribute("data-open-cookie-pref")) {
        if(!cookiePrefLink) {
          cookiePrefLink = document.querySelector(".truste_cursor_pointer");
        }
        _stopDetection(el, e);
        cookiePrefLink.click();
      }

      if((!el.contains(e.target)) || _closeEl.contains(e.target)) {
        _stopDetection(el,e);
      }
      else {
        return false;
      }
    }

    function _setEventListener(el, counter) {
      if(!autoReloadSet) {
        setAutoReload();
        autoReloadSet = true;
      }
      el.addEventListener("click", e => {
        //console.log("popover opener listener");

        if(el.getElementsByClassName("cookiePopover").length < 1) {
          //open the popover
          _openPopover(el, counter, e);
          //set the close listener
          _setDetect = _setDetectClick.bind(null, el);
          document.addEventListener("click", _setDetect, true);
        }
      });
    }

    function _openPopover(el, counter, e) {
      const template = document.createElement('template');
      template.innerHTML = `<div class="ul-popover -fadein on cookiePopover" id="wpopover-${counter}" data-triangle-position="bottom">
        <div class="ul-body">
          <i class="fa fa-close ul-popover__close" data-close="popover" hxboost="false" data-app-tip-dismiss="true"></i>
          In order to enable videos, you must update your cookie preferences. <button class="link" data-open-cookie-pref="true" style="font-size: .875rem">Click here</button> and choose <strong>"Yes"</strong> for <strong>Performance Cookies</strong>, then click <strong>"Submit Preferences."</strong>
        </div>
      </div>`;
      el.insertAdjacentElement('beforeend',template.content.firstElementChild);
      el.querySelector('[data-open-cookie-pref]').focus();
      e.stopImmediatePropagation();
      e.preventDefault();
    }

    var thumbnails = document.querySelectorAll('[data-wfallback-thumbnail=false]'),
        links = document.querySelectorAll('[data-wfallback-link=false]'),
        i = 0;
    //console.log(links);
    thumbnails.forEach( v => {
      v.dataset.wfallbackThumbnail = true;
      _setEventListener(v,i);
      i++;
    });
    links.forEach( l => {
      l.dataset.wfallbackLink = true;
      _setEventListener(l,i);
      i++;
    });
  }

}
